﻿<template>
  <!-- aria-live="polite" am Container: Screenreader kündigen neue Toasts an, ohne den Nutzer zu
       unterbrechen (Fehler zusätzlich per role="alert" auf der einzelnen Toast). -->
  <div
      class="fixed bottom-24 right-6 flex flex-col space-y-3 z-50 max-w-sm w-full pointer-events-none animate-fade-left animate-duration-300 animate-ease-out transition-all duration-200 ease-in"

  >
    <div
        v-for="notification in notifications"
        :key="notification.id"
        :role="notification.type === 'error' ? 'alert' : 'status'"
        class="pointer-events-auto relative overflow-hidden rounded-xl shadow-lg border backdrop-blur-md p-4 flex items-start gap-3 transition-all duration-300"
        :class="{
          'bg-white/90 border-green-200 text-green-800': notification.type === 'success',
          'bg-white/90 border-red-200 text-red-800': notification.type === 'error',
          'bg-white/90 border-yellow-200 text-yellow-800': notification.type === 'warning',
          'bg-white/90 border-blue-200 text-blue-800': notification.type === 'info'
        }"
    >
      <!-- Icon Indicator -->
      <div class="flex-shrink-0 mt-0.5">
        <Iconi v-if="notification.type === 'success'" icon="fa6-solid:circle-check" class="text-lg text-green-500"/>
        <Iconi v-else-if="notification.type === 'error'" icon="fa6-solid:circle-xmark" class="text-lg text-red-500"/>
        <Iconi v-else-if="notification.type === 'warning'" icon="fa6-solid:triangle-exclamation" class="text-lg text-yellow-500"/>
        <Iconi v-else icon="fa6-solid:circle-info" class="text-lg text-blue-500"/>
      </div>

      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium leading-5">{{ notification.message }}</p>
      </div>

      <button
          type="button"
          class="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-md hover:bg-black/5"
          aria-label="Benachrichtigung schließen"
          @click="dismissNotification(notification.id)"
      >
        <Iconi icon="fa6-solid:xmark" class="text-sm"/>
      </button>

      <!-- Fortschrittsbalken: Dauer an die echte Anzeigedauer der Notification gekoppelt
           (dynamischer Wert → :style erlaubt); ohne Auto-Dismiss (duration 0) kein Balken. -->
      <div
          v-if="notification.duration > 0"
          class="absolute bottom-0 left-0 h-0.5 bg-current opacity-20 w-full animate-shrink"
          :style="{animationDuration: `${notification.duration}ms`, animationTimingFunction: 'linear'}"
      ></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useNotificationStore} from '@/stores/notifications';
import {Icon as Iconi} from '@iconify/vue';

const notificationStore = useNotificationStore();

const {notifications} = storeToRefs(notificationStore);

function dismissNotification(id: string) {
  notificationStore.dismiss(id);
}

</script>

<style scoped>
</style>
